/**
 * Referencia de un movimiento de stock, legible. El backend clasifica la referencia (origenDeReferencia en
 * backend/src/wms/origen-movimiento.ts, el mismo clasificador del informe por motivo) y manda la clase y el número;
 * acá sólo se arma el texto y, si hay una pantalla para verlo, el enlace. Sin clase (manual), el texto tal cual.
 */
/** Igual que CLASES_REFERENCIA del backend (origen-movimiento.ts): el test de este archivo las compara. */
export const CLASES_REFERENCIA = [
  'conteo', 'verificacion_estante', 'remito', 'recepcion', 'nota_credito', 'nota_credito_venta', 'devolucion', 'cuarentena', 'venta',
] as const;
export type ClaseReferencia = (typeof CLASES_REFERENCIA)[number];

export interface OrigenReferencia {
  clase: ClaseReferencia;
  id: string | null;
  /** Devoluciones: la OV de la devolución (para el enlace a Devoluciones). */
  ovId?: number;
}

export interface ReferenciaLegible { texto: string; enlace?: string }

export function referenciaLegible(referencia: string | null | undefined, origen?: OrigenReferencia | null): ReferenciaLegible {
  const id = origen?.id ?? '';
  switch (origen?.clase) {
    case 'conteo': return { texto: `Conteo #${id}`, enlace: `/conteos-inventario?conteo=${encodeURIComponent(id)}` };
    case 'verificacion_estante': return { texto: 'Verificación de estante' };
    case 'remito': return { texto: `Remito #${id}`, enlace: `/remitos?remito=${encodeURIComponent(id)}` };
    case 'nota_credito': return { texto: `Nota de crédito de proveedor #${id}` };
    case 'nota_credito_venta': return { texto: `Nota de crédito de venta #${id}` };
    case 'devolucion':
      return origen.ovId != null
        ? { texto: `Devolución #${id} · OV #${origen.ovId}`, enlace: `/devoluciones?ov=${origen.ovId}` }
        : { texto: `Devolución #${id}` };
    case 'cuarentena': return { texto: `Cuarentena · ${id}` };
    // Recepción ("Recepción #40 · Remito R-0001") y venta ("OV #12 · Envío ML 4455") ya se leen bien.
    default: return { texto: referencia || '—' };
  }
}
